var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useActiveDocument } from 'shared/domains/documents';
import { GetDocumentProjectsDocument } from './query.gql';
export const useDocumentProjects = () => {
    const { id: documentId } = useActiveDocument();
    const _a = useQuery(GetDocumentProjectsDocument, {
        variables: { documentId },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { fileSystemProjects = [] } = data || {};
    /**
     *
     * Puts the active document on top
     * Puts all deleted documents on the bottom
     * Sorts the rest alphabetically
     */
    const sortProjectDocuments = (a, b) => {
        if (a.id === documentId) {
            return -1;
        }
        if (b.id === documentId) {
            return 1;
        }
        if (a.deleted && !b.deleted) {
            return 1;
        }
        if (!a.deleted && b.deleted) {
            return -1;
        }
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    };
    const documentFallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name for document in project',
    });
    const projects = fileSystemProjects.map((project) => ({
        id: project.id,
        name: project.name,
        documents: project.nodes
            .map((node) => {
            var _a, _b, _c, _d, _e;
            return ({
                id: (_b = (_a = node.document) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
                name: (_e = (_d = (_c = node.document) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : node.documentLastKnownName) !== null && _e !== void 0 ? _e : documentFallbackName,
                deleted: Boolean(node.documentDeletedAt),
            });
        })
            .sort(sortProjectDocuments),
    }));
    return Object.assign(Object.assign({}, rest), { projects });
};
